<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：组件-选择商品
      -->
    <el-dialog title="选择商品" :visible.sync="dialogVisible" :append-to-body="true" 
    @close="dialogFormVisible"
     :close-on-click-modal="false" :close-on-press-escape="false" 
     
     width="80%" >
   

 
     <div v-if="choose_supply_id">

        <div >
      <div class="mx-auto">
        <chooseW :choose_supply_id="choose_supply_id" @handleCurrentChanges="handleCurrentChanges"></chooseW>


   
        <!-- 产品列表 -->
        <div class="rounded-lg bg-white p-6 shadow-sm">
          <div class="mb-6 flex items-center justify-between">
            <h2 class="text-lg font-medium text-gray-900">产品列表</h2>
            <div class="flex items-center space-x-4">
              <div class="relative">
                <input type="text" 
                       v-model="searchForm.product_name" 
                       placeholder="商品名称" 
                       class="w-64 rounded-lg border-none bg-gray-100 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            
                       <input type="text" 
                       v-model="searchForm.product_no" 
                       placeholder="编码" 
                       class="w-64 rounded-lg border-none bg-gray-100 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            
              
              </div>

    

              <button @click="onSubmit" class="!rounded-button flex items-center space-x-2 bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 whitespace-nowrap">
                <i class="fa-solid fa-plus"></i>
                <span>查询</span>
              </button>
            </div>
          </div>
  
          <div class="overflow-x-auto">
           
            <div class="product-content">
            <div class="table-wrap">
   
              <el-table size="small" :data="productList" border style="overflow-y: auto;  width: 100%;height:400px;" v-loading="loading" 
              @selection-change="tableCurrentChange"  highlight-current-row>
                <el-table-column type="selection"  width="45"></el-table-column>
                <el-table-column prop="product_name" label="产品" width="200px">
                  <template slot-scope="scope">
                    <div class="product-info">
                      <div class="pic"><img v-img-url="scope.row.image.file_path?scope.row.image.file_path:(scope.row.image?scope.row.image:'')" alt="" /></div>

                      <div class="info">
                        <div class="name">{{ scope.row.product_name }}</div>
                        <div class="price">￥{{ scope.row.product_price }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

  
                <el-table-column prop="unit" label="单位"></el-table-column>
        
                <el-table-column prop="spec_value" label="规格"></el-table-column>
        
                <el-table-column prop="product_price" label="价格"></el-table-column>
      
                <el-table-column prop="stock_num" label="实际库存"></el-table-column>
                <el-table-column prop="line_price" label="成本"></el-table-column>

                <el-table-column prop="create_time" label="发布时间"></el-table-column>

                <el-table-column type="selection" :selectable="selectableFunc" width="44" v-if="islist"></el-table-column>
              <el-table-column width="80" label="单选" v-if="!islist">
                <template slot-scope="scope">
                  <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
                  <el-button size="mini" v-else disabled>已选</el-button>
                </template>
              </el-table-column>

        
              </el-table>
            </div>
          </div>
          </div>
  
          <!-- 分页 -->
          <div class="mt-6 flex items-center justify-between">
            <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="curPage"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
              layout="sizes,total, prev, pager, next, jumper"
              :total="totalDataNumber"
            ></el-pagination>
          </div>

          </div>
        </div>
      </div>
    </div>    


      

    </div>
   


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClerk" v-if="islist">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import PorductApi from '@/api/product.js';
  import Supply_s from '@/components/select/warehouse';
  import chooseW from '@/components/select/cwarehouse'; 
  export default {
    components: {
      Supply_s,
      chooseW
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        formInline: {},
        //商品分类列表
        cateList: [],
        //商品列表
        productList: [],
        //类别列表
        status: [
          {
            id: 10,
            name: '上架'
          },
          {
            id: 20,
            name: '下架'
          }
        ],
        multipleSelection: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*结果类别*/
        type:'error',
        /*传出去的参数*/
        params:null,

        batchData:[],
        formInline_batch:{
            search_batch:"",
        
 

        },
        /*当前是第几页*/
        curPage_batch: 1,
        /*一页多少条*/
        pageSize_batch: 10,
        isproduct: false, 
        searchForm:{
          product_name: '',
          category_id: '',
          delivery_id: '',
          product_no:'',
          is_special_view:'',
          brand_id:'',
          is_spec_type:"",
          supply_id:0,
        },
        product_no_search:'',



        warehouses: [
   
        ],
        locations: [

        ],
        selectedWarehouse: null,
        selectedLocation: null,
        searchQuery: '',
      };
    },
    props: ['isBatch', 'excludeIds','islist','choose_supply_id','store_id','t_supply_id'],
    watch:{
        isBatch:function(n,o){
        if(n!=o){
          if(n){
            this.dialogVisible=n;
            this.type='error';
            this.params=null;
            this.getData();
          }
        }
      }
    },
    created() {
      this.productList = [];
    },
    methods: {
  
   
      reasts(){
  
        this.searchForm.warehouse_id = 0
        this.searchForm.warehouse_kw_id = 0
        this.getData();
      },

        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getData();
      },
      handleCurrentChanges(val){

        this.searchForm.warehouse_id = val.warehouse_id
        this.searchForm.warehouse_kw_id = val.warehouse_kw_id
        this.getData();
      },
  
   
  /*是否可以勾选*/
  selectableFunc(e){
      if(typeof e.noChoose !=='boolean'){
        return true;
      }
      return e.noChoose;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*获取商品列表*/
    getData() {
      console.log("走了吗")
      let self = this;
      let params = self.searchForm;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      params.supply_id = self.choose_supply_id;
      params.t_supply_id = self.t_supply_id
      params.store_id = self.store_id;
      params.is_warehouse = 1;
      PorductApi.getSKuProductByBatch(params, true)
        .then(res => {
          if (res.code == 1) {
            self.loading = false;
            self.cateList = res.data.category;
            /*判断是否需要去重*/
            if(self.excludeIds&&typeof(self.excludeIds)!='undefined'&&self.excludeIds.length>0){
              res.data.list.data.forEach(item=>{
                if(self.excludeIds.indexOf(item.product_sku_id)>-1){
                  item.noChoose=false;
                }else{
                  item.noChoose=true;
                }
              });
            }else{
              if(!self.islist){
                 res.data.list.data.forEach(item=>{
                   item.noChoose=true;
                 });
              }
            }
            self.productList = res.data.list.data;
            for(var i=0;i<self.productList.length;i++){
                self.productList[i].supply_id = self.choose_supply_id
            }
            self.totalDataNumber = res.data.list.total;
          }
        })
        .catch(error => {});
    },

    /*单选*/
    SingleFunc(row){
      this.multipleSelection=[row];
      this.addClerk();
    },

    //点击确定
    addClerk() {
      let self = this;
      let params = null;
      let type = 'success';
      console.log("productList",self.productList)
      console.log("this.multipleSelection ",this.multipleSelection )
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请至少选择一件产品商品！',
          type: 'error'
        });
        return;
      }
     params = self.multipleSelection;

       self.params = params;
       self.type = 'success';
       self.dialogVisible = false;
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },

    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.multipleSelection = val;
    }
    }
  };
  </script>
  
  <style>
   .no-list .el-checkbox{ display: none;}
  </style>
  


// WEBPACK FOOTER //
// src/components/product/batch.vue